import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ApiService } from "./api.service";
import { ParameterPaylod, ReportDropDownList, ReportSummaryPayload, ReportTemplateModel, ReportTemplatePayload, ReportWizardCompanyPayload, ReportWizardDetail, ReportWizardDetailPayload, ReportWizardIntializePayload, ReportWizardParameters } from "../models/reports";
import { NextPanel } from "../models/next-panel";

const controllerRoute = '/agent-reports';

@Injectable()
export class ReportsService {

    constructor(
        private apiService: ApiService,
    ) {
    }

    public getReports(): Observable<ReportDropDownList> {
        return this.apiService.get(`${controllerRoute}/reports-dropdown`).pipe(
            map((response: ReportDropDownList) => {
                return response;
            }),
        );
    }

    public initialize(payload: ReportWizardIntializePayload): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/initialize`, payload).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public setCompany(payload: ReportWizardCompanyPayload): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/company`, payload).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getTemplates(): Observable<ReportTemplateModel[]> {
        return this.apiService.get(`${controllerRoute}/templates`).pipe(
            map((response: ReportTemplateModel[]) => {
                return response;
            }),
        );
    }

    public setTemplate(payload: ReportTemplatePayload): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/templates`, payload).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getParameters(): Observable<ReportWizardParameters> {
        return this.apiService.get(`${controllerRoute}/parameter`).pipe(
            map((response: ReportWizardParameters) => {
                return response;
            }),
        );
    }

    public setParameters(payload: ParameterPaylod): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/parameter`, payload).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getDetail(): Observable<ReportWizardDetail> {
        return this.apiService.get(`${controllerRoute}/detail`).pipe(
            map((response: ReportWizardDetail) => {
                return response;
            }),
        );
    }

    public setDetail(payload: ReportWizardDetailPayload): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/detail`, payload).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getSummary(): Observable<ReportSummaryPayload> {
        return this.apiService.get(`${controllerRoute}/summary`).pipe(
            map((response: ReportSummaryPayload) => {
                return response;
            }),
        );
    }

    public proccessReport(): Observable<any> {
        return this.apiService.post(`${controllerRoute}/summary`, null).pipe(
            map((response: any) => {
                return response;
            }),
        );
    }
}
